<ng-container *ngLet="{
  partCount: partCount$ | async,
  loadingResults: loading$ | async
} as vm">
  @if (vm.loadingResults && !vm.partCount) {
    <div id="partBasePortable_div_LoadingPartsData" class="text-center py-5">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <h5 class="mt-3">Loading part(s) ...</h5>
    </div>
  }

  @if (vm.partCount) {
    <div id="partBasePortable_div_PartsData">
      @if (vm.partCount > 1) {
        <part-list id="partBasePortable_part-list_PartSearchTerm"
          [partsData]="parts$ | async"
          [partSearchTerm]="partSearchTerm$ | async"
          [currentPage]="currentPage$ | async"
          [pageSize]="pageSize"
          [branch]="branch$ | async"
          [facets]="facets$ | async"
          [loading]="vm.loadingResults"
          [displayType]="displayType"
          (updateFacets)="updateFacets($event)" 
          (updatePage)="updatePage($event)" 
          (selectPart)="goToPart($event)"
          (partAddedToRequest)="onPartAddedToRequest($event)">
        </part-list>
      }
      @if (vm.partCount == 1) {
        <part-details id="partBasePortable_part-details_PartsData"
          [partSearchTerm]="partSearchTerm$ | async" 
          [partDetail]="parts$ | async"
          [branch]="branch$ | async"
          [displayType]="displayType"
          [isInModal]="isInModal"
          (partSelected)="selectPartFromDetails($event)"
          (navigateToPart)="goToPart($event)"
          (partAddedToRequest)="onPartAddedToRequest($event)">
        </part-details>
      }
    </div>
  }

  @if (showCreatePart$ | async) {
    <create-part
      [partSearchTerm]="partSearchTerm$ | async" 
      (dismiss)="dismissCreatePart()">
    </create-part>
  }
</ng-container>
